module.exports = __webpack_public_path__ + "img/7.dcf40215.png";